import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 10px;
`;

export const Header = styled.div`
  margin: 10px 30px 50px 30px;
  display: flex;
  justify-content: space-between;
`;

export const Card = styled.div`
  margin: 20px auto;
  width: 80%;
  padding: 30px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
`;

export const Head = styled.div``;

export const Content = styled.div`
  height: 100%;
  padding: 30px;
  position: relative;
  overflow: auto;
`;

export const ButtonsArea = styled.div`
  display: flex;
  justify-content: space-between;
  /* width: 97%;
  position: absolute;
  bottom: 80px; */
`;